import { render, staticRenderFns } from "./menuEdit.vue?vue&type=template&id=61b0a246&scoped=true"
import script from "./menuEdit.vue?vue&type=script&lang=js"
export * from "./menuEdit.vue?vue&type=script&lang=js"
import style0 from "./menuEdit.vue?vue&type=style&index=0&id=61b0a246&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b0a246",
  null
  
)

export default component.exports